define('models/linkedcards/linkedcard',["backbone", "models/shared/entityattributes/entityattribute_collection"], function (Backbone, EntityAttributeList) {
	var LinkedCard = Backbone.Model.extend({
		url: function () {
			if (this.instanceURL) return this.instanceURL;
			else return null;
		},
		initialize: function (options) {
			options = options || {};

			this.LinkedCardGUID = options.LGUID;
			this.NetworkSourceID = options.NSID;
			this.SpendingAccountID = options.SAID;
			this.SpendingAccountGUID = options.SAGUID;
			this.NickName = options.NN;
			this.Identifier = options.I;
			this.StatusID = options.SID;
			this.EnrollDate = options.ED;
			this.UnEnrollDate = options.UED;
			this.MessageType = options.MT;
			this.ClientID = options.CID;
			this.CardTypeID = options.CTID;
			this.AvailableBalance = options.AB;
			this.ExtProxyNumber = options.PXYN;
			this.IsDefault = options.ID;
			this.LinkedCardAttributes = new EntityAttributeList(options.LCA, { parse: true });
		},
		parse: function (data) {
			var response = {};

			response.LinkedCardGUID = data.LGUID;
			response.NetworkSourceID = data.NSID;
			response.SpendingAccountID = data.SAID;
			response.SpendingAccountGUID = data.SAGUID;
			response.NickName = data.NN;
			response.Identifier = data.I;
			response.StatusID = data.SID;
			response.EnrollDate = data.ED;
			response.UnEnrollDate = data.UED;
			response.MessageType = data.MT;
			response.CardTypeID = data.CTID;
			response.ClientID = data.CID;
			response.AvailableBalance = data.AB;
			response.ExtProxyNumber = data.PXYN;
			response.IsDefault = data.ID;
			response.IsExpired = data.EXB;
			response.ExpirationMonth = data.EXM;
			response.ExpirationYear = data.EXY;
			response.LinkedCardAttributes = new EntityAttributeList(data.LCA, { parse: true });

			return response;
		},
		save: function (attributes, options) {
			options = options || {};
			attributes = attributes || {};

			var data = {};
			data.LGUID = this.attributes.LinkedCardGUID;
			data.NSID = this.attributes.NetworkSourceID;
			data.SAID = this.attributes.SpendingAccountID;
			data.NN = this.attributes.NickName;
			data.I = this.attributes.Identifier;
			data.SID = this.attributes.StatusID;
			data.ED = this.attributes.EnrollDate;
			data.UED = this.attributes.UnEnrollDate;
			data.MT = this.attributes.MessageType;
			data.CTID = this.attributes.CardTypeID;
			data.LCA = this.attributes.LinkedCardAttributes;
			data.ID = this.attributes.IsDefault;
			this.attributes = data;

			return Backbone.Model.prototype.save.call(this, attributes, options);
		},
	});

	return LinkedCard;
});

